<template>
  <div class="topbar-shell sticky-top border-bottom">
      <div class="container position-relative">
        <div class="d-block position-absolute topbar-back">
          <a href="javascript:" @click="voltar" class="btn topbar-action">
            <i class="fa-solid fa-chevron-left"></i>
          </a>
        </div>
        <div class="topbar-title-wrap">
          <h1 class="font-weight-bold h6 mx-auto limite topbar-title">
            {{title}}
          </h1>
        </div>
      </div>
  </div>
</template>

<script>
export default {
  name: 'TopBar',
  props: ['title', 'url', 'noPadding', 'goClick'],
  methods: {
    voltar(url) {
      if (this.goClick) {
        this.$emit('voltar');

      } else if (this.url) {
        this.$router.push(this.url);

      } else {
        this.$router.go(-1);
      }
    }
  }
}
</script>
<style scoped>
.topbar-shell {
  padding-top: var(--safe-area-inset-top, env(safe-area-inset-top, 0));
  margin-bottom: 24px;
  background-color: rgba(247, 248, 245, 0.86);
  backdrop-filter: blur(18px);
  -webkit-backdrop-filter: blur(18px);
}

.dark-mode .topbar-shell {
  background-color: rgba(15, 17, 16, 0.88);
}

.topbar-title-wrap {
  min-height: 86px;
  padding: 22px 56px 24px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.topbar-title {
  margin: 0;
  max-width: 68%;
  font-size: 1rem;
  letter-spacing: 0.01em;
}

.topbar-back {
  left: 12px;
  top: 20px;
}

.topbar-action {
  width: 42px;
  min-height: 42px;
  padding: 0;
  border-radius: 16px;
  background-color: var(--bg-theme-secondary);
  border: 1px solid var(--border-color);
  color: var(--text-default);
  display: flex;
  align-items: center;
  justify-content: center;
}

.topbar-action:hover,
.topbar-action:focus,
.topbar-action:active {
  background-color: var(--secondary);
  border-color: var(--border-strong);
  color: var(--text-default) !important;
}
</style>
